import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const EstimateFAQ = () => {
  const faqs = [{
    question: "How long does it take to receive my estimate?",
    answer: "Most estimates are provided the same day! For video calls, you'll receive your estimate immediately after the call. For other contact methods, we typically provide estimates within 2-4 hours during business hours."
  }, {
    question: "Do you charge for the estimate?",
    answer: "No, all estimates are completely free! We provide detailed, personalized quotes at no cost and with no obligation to book our services."
  }, {
    question: "What information do you need for an accurate quote?",
    answer: "We need details about your property size, number of rooms, type of cleaning service, frequency, and any special requirements. For commercial properties, we also need square footage and business type. The more details you provide, the more accurate your estimate will be."
  }, {
    question: "Can I modify my cleaning requirements later?",
    answer: "Absolutely! We understand that needs can change. You can modify your service requirements anytime before your scheduled cleaning. We'll adjust your estimate accordingly and confirm any pricing changes."
  }, {
    question: "Do you provide free consultations?",
    answer: "Yes! We offer free video consultations for all clients, which we especially recommend for commercial properties and first-time customers. This allows us to see your space and provide the most accurate estimate possible."
  }, {
    question: "What payment methods do you accept?",
    answer: "We accept credit cards, debit cards, Zelle, and bank transfers. Payment is due after service completion. For recurring services, we can set up convenient automatic billing."
  }, {
    question: "Are your cleaning supplies included?",
    answer: "Yes, we bring all necessary cleaning supplies and equipment. We use professional-grade products. If you have specific product preferences, allergies, or prefer eco-friendly options, just let us know and we'll accommodate your needs."
  }, {
    question: "Do you offer emergency or same-day cleaning?",
    answer: "We do our best to accommodate urgent requests! Contact us directly by phone for same-day or emergency cleaning needs. Additional fees may apply for rush services."
  }];
  return <section className="py-16 bg-muted/30 my-[20px]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Frequently Asked <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">Questions</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Get answers to common questions about our estimate process and cleaning services.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="bg-card border rounded-lg px-6">
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="font-medium">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-6">
                  <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
};
export default EstimateFAQ;